import { option_question, option_level } from "../../../service/option";

import { classNames } from "primereact/utils";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";

export default function ModuleQuestionType1({ closePrePop, popPreOption }) {
  return (
    <>
      <div className="px-3">
        <div className="text-lg font-bold text-blue-600">
          這裡有一些特徵可能適合用來描述你，請針對每一題勾選您同意的程度。
        </div>

        <table className="w-full mt-2">
          <thead>
            <tr>
              <th className="border-bottom-1 border-500"></th>
              {option_level.type1.map((lvItem) => (
                <th
                  key={lvItem.value}
                  className="border-bottom-1 border-500 py-2"
                >
                  {lvItem.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {option_question.type1.map((qItem, qIdx) => (
              <tr key={qItem.key}>
                <td
                  className={classNames({
                    "border-bottom-1 border-500": [2, 5, 8, 11, 14].includes(
                      qIdx
                    ),
                  })}
                >
                  {qIdx + 1}. {qItem.title}
                </td>
                {option_level.type1.map((lvItem) => (
                  <td
                    key={`${qItem.key}_${lvItem.value}`}
                    className={classNames("text-center py-2", {
                      "border-bottom-1 border-500": [2, 5, 8, 11, 14].includes(
                        qIdx
                      ),
                    })}
                  >
                    <Checkbox
                      name={qItem.key}
                      value={lvItem.value}
                      checked={popPreOption.data?.[qItem.key] === lvItem.value}
                      disabled={true}
                    />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>

        <div className="line-height-4 mt-3">
          <div className="font-bold text-lg">計分說明</div>
          <div>
            一、1-3題為外向性、4-6題為友善性、7-9題為嚴謹性、10-12題為神經質、13-15題為開放性。
          </div>
          <div>
            二、計分方式：非常不精確計為1分、有些不精確計為2分、普通計為3分、有些精確計為4分、非常精確計為5分。
          </div>
          <div className="font-bold text-lg mt-3">參考文獻</div>
          <div>
            李仁豪、鍾芯瑜（2020）．中文版簡式五大人格量表BFI的發展．測驗學刊，67（4），271-299。[Li,
            R. H., & Chung, H. Y. (2020). The development of a Chinese shortened
            version of the big five inventory (BFI).{" "}
            <em>Psychological Testing</em>, 67(4), 271-299.]
          </div>
        </div>

        <div className="text-right mt-3">
          <Button
            className="p-button-secondary w-auto px-3"
            type="button"
            label="關閉"
            onClick={() =>
              closePrePop({
                type: "question",
              })
            }
          />
        </div>
      </div>
    </>
  );
}
